export const removeHTMLFromText = (text) => {
  const tempDivElement = document.createElement('div');

  // Set the HTML content with the given value
  tempDivElement.innerHTML = text;

  // Retrieve the text property of the element
  return tempDivElement.textContent || tempDivElement.innerText || '';
};
